import { useEffect, useRef } from "react";
import * as Tone from "tone";

export function useAnalyser() {
  const ref = useRef<Tone.Analyser | null>(null);

  useEffect(() => {
    const analyser = new Tone.Analyser({ type: "fft", size: 128, smoothing: 0.82 });
    Tone.getDestination().connect(analyser);
    ref.current = analyser;
    return () => {
      try { Tone.getDestination().disconnect(analyser); } catch (_) {}
      analyser.dispose();
      ref.current = null;
    };
  }, []);

  return ref;
}
